<template>
  <div
    :class="[
      $style.notificationItemWrapper,
      {
        [$style.notificationItemWrapperPopup]: !isNotificationPage,
        [$style.notificationItemWrapperTransaction]: isNotificationTransaction,
        [$style.notificationItemWrapperWithButton]: variant === 'with-button',
        [$style.notificationItemWrapperWithFullTitle]:
          isNotificationPage && isNotificationFullWidthTitle,
      },
    ]"
  >
    <span v-if="!isNotificationPage" :class="$style.notificationReadedMark" />

    <div :class="$style.notificationItemName">
      <span :class="$style.notificationItemImg">
        <span v-if="isNotificationPage" :class="$style.notificationReadedMarkSmall" />
        <span :class="$style.notificationItemIcon">
          <slot name="icon" />
        </span>
      </span>
      <span v-if="platform.isDesktop" :class="$style.notificationItemTypeTitle">
        {{ notification.data.typeTitle }}
      </span>
      <div v-if="platform.isMobile || platform.isTablet" :class="$style.notificationsItemMobile">
        <span :class="$style.notificationItemTypeTitle">{{ notification.data.typeTitle }}</span>
        <span v-if="!isNotificationExpanded" :class="$style.notificationItemCash">
          {{ notification.data.title }}
        </span>
      </div>
    </div>

    <div v-if="platform.isDesktop" :class="$style.notificationItemInfoTitle">
      <span v-show="!isNotificationExpanded" :class="$style.notificationItemCash">
        {{ snippet.format(notification.data.title) }}
      </span>
    </div>

    <div v-if="$slots.rightSide" :class="$style.notificationItemText">
      <slot name="rightSide" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ENotificationSettingsType, type INotificationFeedElement } from '~/types/notifications';

const props = defineProps({
  notification: {
    type: Object as PropType<INotificationFeedElement>,
    required: true,
  },
  isNotificationExpanded: {
    type: Boolean,
    default: false,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String as PropType<'with-button' | null | undefined>,
    default: null,
  },
});

const snippet = useSnippet();
const platform = usePlatform();

const isNotificationTransaction = computed(
  () =>
    props.notification.type === ENotificationSettingsType.DepositInfo ||
    props.notification.type === ENotificationSettingsType.CashOut
);
const isNotificationFullWidthTitle = computed(
  () =>
    props.notification.type === ENotificationSettingsType.Notification ||
    props.notification.type === ENotificationSettingsType.Welcome ||
    props.notification.type === ENotificationSettingsType.LevelUp
);
</script>

<style lang="scss" module src="./itemWrapper.scss"></style>
